import { TravellerFieldEnum } from '@websky/graphql';
import { getUserValue } from '../../../../utils';
import { format, parseISO } from 'date-fns';
import { fieldIsRequired } from '../../../../Passenger/utils';
export const initialPassengersValuesFactory = (passengers, withDisabilities) => {
    return passengers.map(passenger => {
        const values = {
            type: passenger.type
        };
        if (withDisabilities) {
            values.disabilities = { enabled: false, values: {} };
        }
        passenger.values.forEach(value => {
            if (value.type === TravellerFieldEnum.Nationality &&
                !value.validationRules[0].options.find(option => option.value === value.value)) {
                values[value.name] = value.validationRules[0].options[0].value;
            }
            else {
                values[value.name] = value.value;
            }
        });
        return values;
    });
};
export const clearFieldsMutator = ([passengerIndex], state, utils) => {
    if (typeof passengerIndex !== 'number') {
        console.warn('clearTravellerFieldsMutator: passengerIndex должен быть числом');
        return;
    }
    // Определяем поля TravellerFieldEnum, которые нужно очистить
    const travellerFields = [
        TravellerFieldEnum.LastName,
        TravellerFieldEnum.FirstName,
        TravellerFieldEnum.MiddleName,
        TravellerFieldEnum.BirthDate,
        TravellerFieldEnum.Gender,
        TravellerFieldEnum.Citizenship,
        TravellerFieldEnum.Nationality,
        TravellerFieldEnum.DocType,
        TravellerFieldEnum.DocNumber,
        TravellerFieldEnum.DocExpiryDate,
        TravellerFieldEnum.Phone,
        TravellerFieldEnum.Email
    ];
    // Очищаем только поля TravellerFieldEnum для указанного пассажира
    travellerFields.forEach(fieldName => {
        // Преобразуем первую букву в нижний регистр для соответствия структуре формы
        const camelCaseFieldName = fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
        const fullFieldName = `passengers[${passengerIndex}].${camelCaseFieldName}`;
        // Очищаем значение поля
        utils.changeValue(state, fullFieldName, () => null);
        // Сбрасываем состояние поля
        if (state.fields[fullFieldName]) {
            state.fields[fullFieldName].touched = false;
            state.fields[fullFieldName].visited = false;
            state.fields[fullFieldName].modified = false;
        }
    });
};
export const fillFromDocumentMutator = ([passengerIndex, fillValue, docExpiryDateField], state, utils) => {
    var _a;
    if (typeof passengerIndex !== 'number') {
        console.warn('fillFromDocumentMutator: passengerIndex должен быть числом');
        return;
    }
    if (!fillValue || !fillValue.document) {
        console.warn('fillFromDocumentMutator: fillValue и fillValue.document обязательны');
        return;
    }
    // Создаем Map с данными документа
    const documentPropsMap = new Map(Object.entries({
        birthDate: (() => {
            const raw = getUserValue(fillValue.traveller, TravellerFieldEnum.BirthDate);
            if (!raw) {
                return raw;
            }
            try {
                return format(parseISO(raw), 'dd.MM.yyyy');
            }
            catch (_a) {
                return raw;
            }
        })(),
        docNumber: fillValue.document.number,
        docExpiryDate: fillValue.document.expiryDate,
        docType: fillValue.document.type,
        nationality: fillValue.document.citizenship,
        firstName: fillValue.document.firstName,
        lastName: fillValue.document.lastName,
        middleName: (_a = fillValue.document.middleName) !== null && _a !== void 0 ? _a : '',
        gender: getUserValue(fillValue.traveller, TravellerFieldEnum.Gender),
        email: getUserValue(fillValue.traveller, TravellerFieldEnum.Email),
        phone: getUserValue(fillValue.traveller, TravellerFieldEnum.Phone)
    }).filter(([, value]) => value !== undefined && value !== null));
    if (fillValue.document.values) {
        fillValue.document.values.forEach(item => {
            documentPropsMap.set(item.name, item.value);
        });
    }
    // Заполняем поля формы
    documentPropsMap.forEach((value, fieldName) => {
        const fullFieldName = `passengers[${passengerIndex}].${fieldName}`;
        // Устанавливаем значение поля
        utils.changeValue(state, fullFieldName, () => value);
        // Помечаем поле как измененное
        if (state.fields[fullFieldName]) {
            state.fields[fullFieldName].touched = true;
            state.fields[fullFieldName].modified = true;
        }
    });
    const docExpireIsRequired = fieldIsRequired(state.formState.values['passengers'][passengerIndex], docExpiryDateField.validations);
    if (!docExpireIsRequired) {
        const fullFieldName = `passengers[${passengerIndex}].${docExpiryDateField.name}`;
        utils.changeValue(state, fullFieldName, () => null);
    }
};
